export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export interface NotificationConfig {
  title?: string;
  type?: NotificationType;
  projectId?: string;
  miniappPackageId?: string;
  actions?: Array<{ deeplink?: string; mobileDeeplink?: string }>;
}
